import React, { Suspense } from 'react'
import { renderRoutes } from 'react-router-config'
import { makeStyles } from '@material-ui/styles'
import { LinearProgress } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  content: {
    height: '100%',
    paddingTop: 56,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64,
    },
  },
}))

export const Publico = (props) => {
  const { route } = props

  const classes = useStyles()

  return (
    <main className={classes.content}>
      <Suspense fallback={<LinearProgress />}>{renderRoutes(route.routes)}</Suspense>
    </main>
  )
}
